import { render, staticRenderFns } from "./TableCellCommentAndActions.vue?vue&type=template&id=088cb092&"
import script from "./TableCellCommentAndActions.vue?vue&type=script&lang=ts&"
export * from "./TableCellCommentAndActions.vue?vue&type=script&lang=ts&"
import style0 from "./TableCellCommentAndActions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports